/**
 * RTL direction tokens. W0-19.
 *
 * Not a `:root` custom-property block in the source — the source sets
 * direction once, on `body { direction: rtl; }`. This package makes that
 * choice a named, exported token rather than a string a caller re-types, so
 * a consumer sets `dir`/`lang` from one place and cannot drift from the
 * source's own default.
 *
 * SOT §7.5 and the product are Persian-first; `ltr` exists here only for a
 * caller that genuinely needs to embed Latin-only content (e.g. a raw code
 * block) inside an otherwise RTL document, not as an equal alternative.
 */
export const directionTokens = {
    '--direction': 'rtl',
};
/** The two HTML attribute values a Persian-first, RTL-default document needs. */
export const RTL_HTML_ATTRS = { dir: 'rtl', lang: 'fa' };
export const LTR_OVERRIDE_ATTRS = { dir: 'ltr' };
//# sourceMappingURL=direction.js.map